import { environment } from '../../../environments/environment';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  BillingManagementLink,
  BillingPayNowResult,
  BillingStatusResponse,
} from '../models/billing.interface';
import { SKIP_ERROR_TOAST } from '../interceptors/skip-error-toast';

@Injectable({
  providedIn: 'root',
})
export class BillingAdaptor {
  private http = inject(HttpClient);

  // No error toast: the API answers 404 while billing is switched off, which is normal, not a
  // failure to show. BillingStateService reads the status and decides what the screen says.
  getStatus(tenantId: number): Observable<BillingStatusResponse> {
    return this.http
      .get<BillingStatusResponse>(`${environment.apiUrl}/${tenantId}/billing`, {
        context: new HttpContext().set(SKIP_ERROR_TOAST, true),
      })
      .pipe(catchError(this.handleError<BillingStatusResponse>('getStatus')));
  }

  // Unlike getStatus, a failure here IS shown to the user: they clicked a button and nothing happened.
  createManagementLink(tenantId: number): Observable<BillingManagementLink> {
    return this.http
      .post<BillingManagementLink>(`${environment.apiUrl}/${tenantId}/billing/management-link`, {})
      .pipe(catchError(this.handleError<BillingManagementLink>('createManagementLink')));
  }

  // A failure here IS shown to the user (card declined, nothing to pay): the API's message is the toast.
  payNow(tenantId: number): Observable<BillingPayNowResult> {
    return this.http
      .post<BillingPayNowResult>(`${environment.apiUrl}/${tenantId}/billing/pay-now`, {})
      .pipe(catchError(this.handleError<BillingPayNowResult>('payNow')));
  }

  private handleError<T>(operation = 'operation') {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed in BillingAdaptor:`, error);
      throw error;
    };
  }
}
